import apiClient from "../apiClient";

export const canCreateProperty = async (instance) => {
  const client = await apiClient(instance);
  const response = await client.get('/api/SelfService/can-create-property');
  return response.data;
};

export const createProperty = async (propertyData, instance) => {
  const client = await apiClient(instance);
  const response = await client.post('/api/SelfService/create-property', {
    propertyName: propertyData.propertyName,
    propertyDescription: propertyData.propertyDescription,
    city: propertyData.city,
    country: propertyData.country,
    businessEmail: propertyData.businessEmail,
    businessPhone: propertyData.businessPhone,
    streetAddress: propertyData.streetAddress,
    businessType: propertyData.businessType
  });
  return response.data;
};
